import type { FaireProductEntity } from "../../entity_types/product";

export const p_q55yjqh48v: FaireProductEntity = {
  token: "p_q55yjqh48v",
  type: "product",
  name: "DOUBLE CHAIN INITIALS PENDANT NECKLACE_CWAJE106",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/313d27386823862c417cff67d8abb0aedb327b8bf4fefee9d2bea06480e54a5d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9915c56b1d3ee158fba65ddc369276696b946869131c2ce221c5c28aab9cb6ec.jpeg",
    "https://cdn.faire.com/fastly/174eb879357cb402b05b45364bd38fc45ad20a72d7396f9806a64b04774cdf27.jpeg",
    "https://cdn.faire.com/fastly/557a973d5a2450533d17e43596ee694c72da366ef544a60b0f426b12744c6f23.jpeg",
    "https://cdn.faire.com/fastly/bc51bdd82723b3aefee4037d6fed9e1a2d9acea3585be479c7013ff2306876c4.jpeg",
    "https://cdn.faire.com/fastly/89540992171a6eab7ac1221f69179190dd47336a970d3af04dcfebc82800a81d.jpeg",
    "https://cdn.faire.com/fastly/6968bd5bb770a4935005516906286319127b678b3c00f8faecf02c4b0a5c4237.jpeg",
    "https://cdn.faire.com/fastly/fff5042d5f1634a574f12a1717e4d037f163af3195675309ddf197f0d4069fbe.jpeg",
    "https://cdn.faire.com/fastly/88baeeead9cbc889aca2683ff94f25d6e645d5b41d0d4567f2a5e329003b4842.jpeg",
    "https://cdn.faire.com/fastly/b5ceef78058b26a7f018dbc9ff63ffd725dc301b9b46d8d25c3cfcab45885086.jpeg",
    "https://cdn.faire.com/fastly/2f1a0975423c6994bc52e4d552bcf9df7a934264cf2f88cf7cfa574a6bd052bf.jpeg",
    "https://cdn.faire.com/fastly/b138df5e3544b0b8b61a69eb54363142bdf2ab033c62826680378fa7ee8d581f.jpeg",
    "https://cdn.faire.com/fastly/c3536efd9fa82ccce9dc2e806169bddaa490b04c472c07c3d556a06390bc34a5.jpeg",
    "https://cdn.faire.com/fastly/a33ea1c89489528bdec9d14164d6a1af13d275d0404b2964a7edc1e992d7dd03.jpeg",
    "https://cdn.faire.com/fastly/b6a7b970ae9c5712cb427534e07212862d8b0e62c9625fe12ec3de11d0a556d6.jpeg",
    "https://cdn.faire.com/fastly/dc8b2972b1880cf71716d3a5188a5bf65cd2150b54a28b580c2eee9257274ce4.jpeg",
    "https://cdn.faire.com/fastly/42924d3ffeb084fa68a4da973e4155eb2a95a8354b5420f15a80ea7758ee06c2.jpeg",
    "https://cdn.faire.com/fastly/55e619aa7a1e811c4ccfbd0b10dafb1299d2539c4a02166fc0dd142eced449cb.jpeg",
    "https://cdn.faire.com/fastly/eb029659acba24696b5a78aea5eaff3b347487ab0c6c36f17f54a3ceb62c8849.jpeg",
  ],
  priceDollars: 4.14,
  description: "DOUBLE CHAIN INITIALS PENDANT NECKLACE\n\nACZG017A72",
  tags: [],
  msrpDollars: 8.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:00.561Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
